import {
  IPageDataOffer,
  IPageDataOfferDefaultData,
} from '@ucheba/store/page-data/offer/types'
import { useMemo } from 'react'

export interface IUseTimerData {
  (
    data: Array<IPageDataOffer> | null,
    options?: IPageDataOfferDefaultData
  ): IPageDataOffer | null
}

/* проверяем элементы на на актульность даты и времени */
const getCorrectDateItem = (items: Array<IPageDataOffer>): IPageDataOffer | null => {
  const nowDate = new Date()

  const correctDateItem = items.find((item) => {
    const startDate = new Date(item.startDate)
    const endDate = new Date(item.endDate)

    return startDate < nowDate && endDate > nowDate
  })

  return correctDateItem || null
}

/* хук для получения актуальной акции */
export const useTimerData: IUseTimerData = (data, options) => {
  const content = useMemo(() => {
    if (!data) return null

    if (options) {
      const { types, subjects, classes } = options

      // получаем список элементов которые соответсвуют options
      const actuals = data.filter((item) => {
        const hasTypes =
          types && item.types && item.types.length > 0
            ? item?.types?.some((el) => types.includes(el))
            : true
        const hasClasses =
          classes && item.classes && item.classes.length > 0
            ? item.classes?.some((el) => classes.includes(el))
            : true
        const hasSubjects =
          subjects && item.subjects && item.subjects.length > 0
            ? item.subjects?.some((el) => subjects.includes(el))
            : true

        return hasTypes && hasClasses && hasSubjects
      })

      if (actuals && actuals.length > 0) {
        const actualData = getCorrectDateItem(actuals)

        if (actualData) {
          return actualData
        }
      }

      return null
    }

    return getCorrectDateItem(data)
  }, [data, options])

  return content
}
